import mobx, {
  observable,
  action,
  computed,
} from 'mobx';

import intersectionWith from 'lodash/intersectionWith';
import intersection from 'lodash/intersection';
import unionWith from 'lodash/unionWith';
import pullAll from 'lodash/pullAll';
import union from 'lodash/union';
import pull from 'lodash/pull';
import uniq from 'lodash/uniq';
import xor from 'lodash/xor';

import api from '../../api';
import appStore from '../appStore';


export default class LineMenuStore {
  store = null;
  status = 0;
  @observable isLoadMenu = true;
  @observable sport = new Map();
  @observable league = new Map();
  @observable games = new Map();
  @observable mode = '';
  @observable other = [];
  @observable sportOrder = [];
  @observable selected = {
    sport: [],
    league: [],
    gmaes: [],
    fav: false,
    popular: false,
		video: false,
  };
  @observable type = null;
  @observable dict = {};
  @observable isOpen = {
    favourites: false,
    popular: false,
    other: true,
		video: false,
    sport: [],
    league: [],
  };
  @observable favourites = {
    games: [],
    sport: [],
    league: [],
    popular: {
      pop: [],
    },
  };
  refreshTimer = null;
	refreshVideoTimer = null;
	@observable popular = {
    items: {},
    order: [],
    count: 0,
  };

	@observable video = {
		games: [],
		count: 0,
	};

  constructor(store) {
    this.store = store;
  }

  @action init() {
    this.mode = this.store.mode;
    this.loadMenu();
    // запрос ajax/video/get_list скрыт WEBDEV-16872
		// if (this.mode === 'live') {
    //   this.loadVideo();
    //   this.refreshVideoTimer = setInterval(() => this.loadVideo(), 60000);
    // }
  }

  despose() {
    clearInterval(this.refreshTimer);
    clearInterval(this.refreshVideoTimer);
    this.isLoadMenu = true;
    this.status = 0;
    this.sport.clear();
    this.league.clear();
    this.games.clear();
    this.mode = '';
    this.other = [];
    this.sportOrder = [];
    this.selected = {
      games: [],
      sport: [],
      league: [],
      fav: false,
      popular: false,
			video: false,
    };
    this.isOpen = {
      favourites: false,
      popular: false,
      other: true,
      sport: [],
      league: [],
			video: false,
    };
    this.favourites = {
      games: [],
      sport: [],
      league: [],
      popular: {
        pop: [],
      },
    };
    this.popular = {
      items: {},
      order: [],
      count: 0,
    };
		this.video = {
			games: [],
			count: 0,
		};
  }

  clearSelected() {
    this.selected = {
      games: [],
      sport: [],
      league: [],
      fav: false,
      popular: false,
      video: false,
    };
  }

  @action toggleOpenItem(id, type, lid) {
    switch (type) {
      case 0:
        this.isOpen.favourites = !this.isOpen.favourites;
        break;
      case 1:
        if (this.isOpen.sport.indexOf(id) === -1) {
          this.isOpen.sport.push(id);
        } else {
          pull(this.isOpen.sport, id);
        }
        break;
      case 2:
        if (Array.isArray(id)) {
          if (this.mode === 'line') {
            this.isOpen.sport = id.map(i => this.league.get(i).sid);
          } else {
            this.isOpen.sport = this.isOpen.sport.concat(id.map(i => this.league.get(i).sid));
          }
          this.isOpen.league = id;
        } else {
          if (this.isOpen.league.indexOf(id) === -1) {
            this.isOpen.league.push(id);
          } else {
            pull(this.isOpen.league, id);
          }
        }
        break;
      case 3:
        if (Array.isArray(id)) {
          if (this.mode === 'line') {
            this.isOpen.sport = id.map(i => this.games.get(i).sid);
            this.isOpen.league = id.map(i => this.games.get(i).lid);
          } else {
            this.isOpen.sport = this.isOpen.sport.concat(id.map(i => this.games.get(i).sid));
            this.isOpen.league = this.isOpen.league.concat(id.map(i => this.games.get(i).lid));
          }
          this.isOpen.games = id;
        } else {
          if (this.isOpen.sport.indexOf(id) === -1) {
            this.isOpen.sport.push(id);
          }
          if (this.isOpen.league.indexOf(lid) === -1) {
            this.isOpen.league.push(lid);
          }
        }
        break;
      case 4:
        this.isOpen.popular = !this.isOpen.popular;
        break;
      case 5:
        this.isOpen.other = id !== null ? true : !this.isOpen.other;
        break;
			case 6:
				this.isOpen.video = !this.isOpen.video;
				break;
      default:
        this.isOpen = {
          favourites: false,
          popular: false,
          other: true,
          video: false,
          sport: [],
          league: [],
        };
        break;
    }
  }

  @action setSelect(id) {
    if (this.games.get(id)) {
      this.selected.games.push(id);
      this.toggleOpenItem(this.games.get(id).sid, 3, this.games.get(id).lid);
    }
  }

  @action selectOther() {
    this.toggleOpenItem(true, 5);
    this.selectItem({sport: mobx.toJS(this.other)}, 1);
  }

  handleSelect(ids, type) {
    switch (type) {
      case 0:
        this.selected = {...this.selected, video: false, fav: ids, pop: false, sport: [], league: [], games: []};
        this.toggleOpenItem(null, type);
        break;
      case 1:
        this.selected = {...this.selected, video: false, fav: false, pop: false, sport: ids, league: [], games: []};
        this.toggleOpenItem(ids, type);
        break;
      case 2:
        this.selected = {...this.selected, video: false, fav: false, pop: false, sport: [], league: ids, games: []};
        this.toggleOpenItem(ids, type);
        break;
      case 3:
        this.selected = {...this.selected, video: false, fav: false, pop: false, sport: [], league: [], games: ids};
        this.toggleOpenItem(ids, type);
        break;
      case 4:
        this.selected = {...this.selected, video: false, fav: false, pop: ids, sport: [], league: [], games: []};
        this.toggleOpenItem(null, type);
        break;
      case 6:
        this.selected = {...this.selected, video: true, fav: false, pop: false, sport: [], league: [], games: []};
        this.toggleOpenItem(null, 6);
        break;
    }
  }

  @action selectItem(id, type) {
    this.store.toggleSchedule(false);
    this.type = type ? type : null;
    let sport = [];
    let league = [];
    let games = [];
    let popular_group = [];
    let video = false;
    switch (type) {
      case 0:
        sport = mobx.toJS(this.favourites.sport);
        league = mobx.toJS(this.favourites.league);
        games = mobx.toJS(this.favourites.games);
        popular_group = mobx.toJS(this.favourites.popular.pop);
        this.handleSelect(true, type);
        break;
      case 1:
        if (Array.isArray(id.sport)) {
          sport = id.sport;
        } else {
          sport.push(id);
        }

        this.handleSelect(sport, type);

        sport.forEach(el => {
          if (this.sport.get(el)) {
            league = league.concat(mobx.toJS(this.sport.get(el).league));
          }
        });

        league.forEach(el => {
          games = games.concat(mobx.toJS(this.league.get(el).games));
        });

        break;
      case 2:
        if (Array.isArray(id.league)) {
          league = id.league;
        } else {
          league.push(id);
        }

        this.handleSelect(league, type);

        league.forEach(el => {
          if (this.league.get(el)) {
            games = games.concat(mobx.toJS(this.league.get(el).games));
            sport.push(this.league.get(el).sid);
          }
        });

        break;
      case 3:
        if (Array.isArray(id.games)) {
          games = id.games;
        } else {
          games.push(id);
        }

        this.handleSelect(games, type);

        games.forEach(el => {
          if (this.games.get(el)) {
            league.push(this.games.get(el).lid);
            sport.push(this.games.get(el).sid);
          }
        });
        break;
      case 4:
        Object.keys(this.popular.items).forEach(id => {
          popular_group.push(id);
          this.handleSelect(true, type);
        });
        break;
      case 5:
        popular_group = [id];
        break;
      case 6:
        video = true;
        this.handleSelect(true, type);
        break;
    }
    this.store.line.selectItem({
      sport: uniq(sport),
      league: league,
      games: games,
      popular_group: popular_group,
      video
    }, type);
  }

  favoriteMatch = action((matchID, isFavourite) => {
    const id = Number(matchID);
    if (isFavourite && this.favourites.games.includes(id)) { return; }
    isFavourite ?
      this.favourites.games.push(id) :
      this.favourites.games.splice(this.favourites.games.indexOf(id), 1);
    this.saveFav();
  });

  favoriteChampionship = action((championshipID, isFavourite) => {
    if (isFavourite && this.favourites.league.includes(championshipID)) { return; }
    isFavourite ?
      this.favourites.league.push(championshipID) :
      this.favourites.league.splice(this.favourites.league.indexOf(championshipID), 1);
    this.saveFav();
  })

  @action toggleFav(id, type) {
    id = parseInt(id);
    switch (type) {
      case 0:
        this.favourites.sport = [];
        this.favourites.league = [];
        this.favourites.games = [];
        this.favourites.popular = {
          pop: [],
        };
        this.isOpen.favourites = false;
        break;
      case 1:
        if (this.favourites.sport.indexOf(id) !== -1) {
          pull(this.favourites.sport, id);
          pullAll(this.favourites.league, this.sport.get(id).league);
          this.sport.get(id).league.forEach(i => pullAll(this.favourites.games, this.league.get(i).games));
        } else {
          this.favourites.sport.push(id);
          this.favourites.league = this.favourites.league.concat(this.sport.get(id).league);
          this.sport.get(id).league.forEach(i => this.favourites.games = union(this.favourites.games, this.league.get(i).games));
        }
        break;
      case 2:
        // чемпионат
        if (this.favourites.league.indexOf(id) !== -1) {
          pull(this.favourites.league, id);
          pullAll(this.favourites.games, this.league.get(id).games);
        } else {
          this.favourites.sport.push(this.league.get(id).sid);
          this.favourites.league.push(id);
          this.favourites.games = unionWith(this.favourites.games, this.league.get(id).games);
        }
        break;
      case 3:
        // матч
        if (this.favourites.games.indexOf(id) !== -1) {
          pull(this.favourites.sport, this.games.get(id).sid);
          pull(this.favourites.league, this.games.get(id).lid);
          pull(this.favourites.games, id);
        } else {
          this.favourites.games.push(id);
        }
        break;
      case 4:
        if (this.favourites.popular.pop.indexOf(id) !== -1) {
          pull(this.favourites.popular.pop, id);
        } else {
          this.favourites.popular.pop.push(id);
        }
        break;
      default:
        break;
    }
    if (this.favourites.games.length === 0 && this.favourites.popular.pop.length === 0) {
      this.selected.fav = false;
      appStore.history.push(`/${ this.mode }`);
    }

    this.saveFav();
  }

  @computed get countFav() {
    let count = 0;
    this.favourites.popular.pop.forEach(i => {
      count += this.popular.items[i].games_count;
    });
    return this.favourites.games.length + count;
  }

  @action getFav() {
    const ls = JSON.parse(localStorage.getItem(`favourites_${ this.mode }`));
    if (ls) {
      const lineGames = this.games.keys();
      const lineLeague = this.league.keys();
      const lineSport = this.sport.keys();
      const games = intersectionWith(ls.games, lineGames, (x, y) => x == y);
      const league = intersectionWith(ls.league, lineLeague, (x, y) => x == y);
      const sport = intersectionWith(ls.sport, lineSport, (x, y) => x == y);
      const pop = intersectionWith(ls.popular.pop, this.popular.order, (x, y) => x == y);
      if (games.length) {
        this.favourites.games = games;
      }
      if (league.length) {
        this.favourites.league = league;
      }
      if (sport.length) {
        this.favourites.sport = sport;
      }
      if (pop.length) {
        this.favourites.popular.pop = pop;
      }
    }
  }

  @action saveFav() {
    localStorage.setItem(`favourites_${ this.mode }`, JSON.stringify(this.favourites));
  }

  @action loadMenu() {
    api[`${ this.mode }Menu`].get({cashboxMode: appStore.cashboxMode }).then(
      action(data => {
        if (data.result) {
          this.dict = data.result.dict;
          this.addSport(data.result.sport);
          this.addLeague(data.result.league);
          this.addGame(data.result.games);
          if (this.mode === 'line') {
            this.other = intersection(data.result.sort.sport, data.result.menu.other);

            const mainSports = data.result.sort.sport.filter(sport => !data.result.menu.other.includes(sport));
            if (data.result.order.length > 0 && !!data.result.order.find(sport => typeof sport === 'string')) {
              mainSports.push(data.result.order[data.result.order.length - 1]);
            }
            this.addOrder([...mainSports]);
          } else {
            this.addOrder(data.result.sort.sport);
          }
          this.refreshTimer = setInterval(() => this.refreshMenu(), this.mode === 'live' ? 3000 : 60000000);
          if (this.mode === 'line' && data.result.popular) this.addPopular(data.result.popular);
          this.getFav();
          this.store.init2();
          this.status = 1;
        }
      }))
      .catch(action(err => {
        // this.liveError = err.response && err.response.body && err.response.body.errors;
        // throw err;
      }))
      .finally(action(() => {
        this.isLoadMenu = false;
      }));
  }

  @action refreshMenu() {
    api[`${ this.mode }Menu`].get({cashboxMode: appStore.cashboxMode }).then(
      action(data => {
        if (data.result) {
          this.dict = data.result.dict;
          this.addSport(data.result.sport);
          this.addLeague(data.result.league);
          this.addGame(data.result.games);
          if (this.mode === 'line') {
            this.other = intersection(data.result.sort.sport, data.result.menu.other);

            const mainSports = data.result.sort.sport.filter(sport => !data.result.menu.other.includes(sport));
            if (data.result.order.length > 0 && !!data.result.order.find(sport => typeof sport === 'string')) {
              mainSports.push(data.result.order[data.result.order.length - 1]);
            }
            this.addOrder([...mainSports]);
          } else {
            this.addOrder(data.result.sort.sport);
          }
          if (this.mode === 'line' && data.result.popular) this.addPopular(data.result.popular);
          this.store.line.refreshSelected();
        }
      }))
      .catch(action(err => {
        // this.liveError = err.response && err.response.body && err.response.body.errors;
        // throw err;
      }));
  }

  @action addSport(sport) {
    let s;
    if (sport) {
      for (const item in sport) {
        if (this.sport.has(item)) {
          s = xor(mobx.toJS(this.sport.get(item).league), sport[item].league);

          if (s.length > 0) {
            this.sport.get(item).league = sport[item].league;
          }
        } else {
          sport[item]['name'] = this.dict.sport[item];
          this.sport.set(item, sport[item]);
        }
      }
    } else {
      this.sportOrder = [];
      this.sport.clear();
    }
  }

  @action addLeague(league) {
    let l;
    if (league) {
      for (const item in league) {
        if (this.league.has(item)) {
          l = xor(mobx.toJS(this.league.get(item).games), league[item].games);
          if (l.length > 0) {
            this.league.get(item).games = league[item].games;
          }
        } else {
          league[item]['name'] = this.dict.league[item];
          this.league.set(item, league[item]);
        }
      }
    }
  }

  @action addGame(games) {
    // let idx;
    if (games) {
      for (const item in games) {
        if (!this.games.has(item)) {
          games[item]['c1'] = this.dict.cmd[games[item].c1_id];
          if (games[item].c2_id) games[item]['c2'] = this.dict.cmd[games[item].c2_id];
          this.games.set(item, games[item]);
        }
      }
    } else {
      this.games.clear();
    }
  }

  @action refreshFavoriteGames() {
    this.favourites.games = this.favourites.games.map(item => {
      if (this.games.has(item)) return item;
    });
  }

  @action addOrder(order) {
    if (xor(order, mobx.toJS(this.sportOrder)).length > 0) {
      this.sportOrder = order;
    }
  }

  @action addPopular(popular) {
    let count = 0;
    for (let i in popular.data) {
      count += popular.data[i].games_count;
    }
    this.popular.items = popular.data;
    this.popular.order = popular.order;
    this.popular.count = count;
    this.dict['popular'] = popular.dict.popular;
  }

  @computed get countOther() {
    this.other();
  }

	loadVideo() {
		api.liveMenu.getVideo().then(
			action(data => {
				if (data.result) {
					this.video.games = data.result.games;
					this.video.dict = data.result.dict;
					this.video.count = data.result.count;
				}
			}),
		);
	}
}



// WEBPACK FOOTER //
// ./src/stores/lineStore/menu.js